/* istanbul ignore file */
export const WIDGET_TYPE_DESCRIPTIONS = {
    PIE: 'Shows how records are distributed across categories as proportional slices of a whole, with an optional center space for improved readability.',
    NUMBER: 'Displays a single key metric or aggregate value at a glance.',
    REPORT: 'Shows a condensed version of an existing report and select which columns to display.',
    MAP: (sitesAlias: string, projectAlias: string): string => `Displays ${sitesAlias} associated with the selected ${projectAlias} on an interactive map.`,
    PROJECT_NOTE: (projectAlias: string): string => `Shows selected ${projectAlias} notes to highlight updates, context, or important information.`
};
